import React, { useEffect, useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Collapsible from 'react-collapsible'
import moment from 'moment'
import { groupBy, reverse } from 'lodash'

const Articles = ({ onUpdate }) => {
  const [articles, setArticles] = useState(undefined)

  useEffect(() => {
    if (articles == undefined) {
      var items = getArticlesList(allMarkdownRemark.group)
      setArticles(items)
    }
  }, [articles])

  const { allMarkdownRemark } = useStaticQuery(
    graphql`
      query {
        allMarkdownRemark(sort: { fields: frontmatter___date, order: ASC }) {
          group(field: frontmatter___date) {
            fieldValue
            nodes {
              frontmatter {
                title
              }
              fields {
                slug
              }
            }
          }
        }
      }
    `
  )

  const getArticlesList = (collection) => {
    moment.suppressDeprecationWarnings = true
    var newCol = collection.map((item) => {
      let col = {}
      col.period = moment(item.fieldValue).format('MMM yyyy')
      col.articles = item.nodes.map((node) => {
        let article = {}
        article.title = node.frontmatter.title
        article.slug = node.fields.slug
        return article
      })
      return col
    })
    var group = groupBy(newCol, 'period')

    Object.keys(group).forEach(function (key) {
      var flat = []
      group[key].forEach((element) => {
        element.articles.forEach((subelement) => {
          flat.push(subelement)
        })
      })
      group[key] = flat
    })

    // 2 levels
    var orderedDates = {}
    Object.keys(group)
      .sort(function (a, b) {
        return moment(b, 'MMM yyyy').toDate() - moment(a, 'MMM yyyy').toDate()
      })
      .forEach(function (value) {
        orderedDates[value] = group[value]
      })

    // 3 levels
    const groupedByYear = {}
    Object.keys(orderedDates).map((key, index) => {
      const [month, year] = key.split(' ')
      let item = {}
      item.period = key
      item.posts = orderedDates[`${key}`]
      if (groupedByYear[year]) {
        groupedByYear[year].push(item)
      } else {
        groupedByYear[year] = []
        groupedByYear[year].push(item)
      }
    })

    return groupedByYear
  }

  return (
    articles != undefined &&
    Object.keys(articles).reverse().map((key, index) => {
      return (
        <Collapsible
          key={`${key}`}
          trigger={`${key}`}
          onTriggerOpening={onUpdate}
        >
          {articles[`${key}`].map((element, i) => {
            return (
              <Collapsible
                key={`${element.period}`}
                trigger={`${element.period}`}
                onTriggerOpening={onUpdate}
              >
                <ul>
                  {element.posts.map((item, i) => {
                    return (
                      <li key={i}>
                        <a href={item.slug} title={item.title}>
                          - {item.title}
                        </a>
                      </li>
                    )
                  })}
                </ul>
              </Collapsible>
            )
          })}
        </Collapsible>
      )
    })
  )
}

export default Articles
